<template>
  <div>
    <Card title="Ratings">
      <template v-slot:body>
        <div>
          <div class="pb-6 flex justify-between items-center">
            <div class="flex items-center">
              <div class="mr-2">
                <el-input placeholder="search name" v-model="filter.q" @change="searchSurvey" ></el-input>
              </div>
              <Button @clicked="searchSurvey" label="Apply"/>
              <button class="p-2" ><font-awesome-icon :icon="['fas', 'sync']" @click="resetSurvey" /></button>
            </div>
            <download-excel
              class="md:w-50"
              :data="data"
              :fields="excel_fields"
              :meta="excel_meta"
              worksheet="My Worksheet"
              name="surveys.xls"
            >
              <div v-bind:class="'bg-indigo-500 text-gray-100'" class="flex items-center px-4 py-3 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100">
                <p class="m-auto text-xs font-medium">
                  Download Excel
                </p>
              </div>
            </download-excel>
          </div>
        </div>
        <data-tables-server ref="tableSurvey" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [20,50,100,300,500] }" @query-change="onChangeTable" >
          <el-table-column v-for="title in titles" :prop="title.prop.field" :label="title.label" :key="title.prop.field" sortable="custom">
          </el-table-column>
          <el-table-column label="Actions" align="right" min-width="100px">
            <template slot-scope="scope">
              <div class="static inline-block text-left container-action">
                <VueCustomTooltip label="See Detail" :position="'is-left'">
                  <a @click="detail(scope.row)" class="inline-block p-2 w-8 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'eye']" />
                  </a>
                </VueCustomTooltip>
              </div>
            </template>
          </el-table-column>
        </data-tables-server>
      </template>
    </Card>
    <ModalDialogDetail
      :isShowingModal="isShowingModal"
      :isLoading="isLoading"
      title="Detail Survey"
      @toggleModal="toggleModal()"
    >
      <template slot="body" >
        <div class="py-6" style="min-width: 360px">
          <form-item label='Name'>
            <template v-slot>
              <p class="text-left font-bold">{{ selectedRow!=null?selectedRow.customer_name:'-' }}</p>
            </template>
          </form-item>
          <form-item label='Email'>
            <template v-slot>
              <p class="text-left font-bold">{{ selectedRow!=null?selectedRow.customer_email:'-' }}</p>
            </template>
          </form-item>
          <form-item label='Country'>
            <template v-slot>
              <p class="text-left font-bold">{{ selectedRow!=null?selectedRow.country:'-' }}</p>
            </template>
          </form-item>
          <form-item label='Submission Date'>
            <template v-slot>
              <p class="text-left font-bold">{{ selectedRow!=null?selectedRow.submission_date:'-' }}</p>
            </template>
          </form-item>
          <form-item label='Attempts'>
            <template v-slot>
              <p class="text-left font-bold">{{ selectedRow!=null?selectedRow.attempts:'-' }}</p>
            </template>
          </form-item>

          <template v-if="selectedRow!=null">
            <form-item label='Answers'>
              <template v-slot>
                <ul>
                  <li v-for="(q, index) in selectedRow.feedback" :key="index" class="mb-6">
                    <h2 class="text-xl font-bold text-left">{{q.title}}</h2>
                    <p class="text-left">{{q.question}}</p>
                    <ul class="list-disc ml-4">
                      <li v-for="(opt, index2) in q.feedback" :key="index2">
                        <p class="text-left">{{opt.option}} {{opt.value.length>0?`: ${opt.value}`:''}}</p>
                      </li>
                    </ul>
                  </li>
                </ul>
              </template>
            </form-item>
          </template>
        </div>
      </template>
    </ModalDialogDetail>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import JsonExcel from 'vue-json-excel';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import moment from 'moment';
import ModalDialogDetail from '../../components/Common/ModalDialogDetail';
import { Button, FormItem } from '@/components/Layout/Form';
import Card from '@/components/Layout/Card.vue';
import CardStats from '@/components/Layout/CardStats.vue';

Vue.component('downloadExcel', JsonExcel);
export default {
  name: 'SurveyList',
  data() {
    return {
      excel_fields: {
        Name: 'customer_name',
        'User Email': 'customer_email',
        Country: 'country',
        'Submission Date': 'submission_date',
        Attempts: 'attempts',
      },
      excel_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8',
          },
        ],
      ],
      isLoading: false,
      isShowingModal: false,
      utc_offset: Math.floor(moment().utcOffset() / 60),
      data: [],
      total: 0,
      displayingItem: 20,
      titles: [{
        prop: {
          field: 'customer_name',
        },
        label: 'Name',
      }, {
        prop: {
          field: 'customer_email',
        },
        label: 'User Email',
      }, {
        prop: {
          field: 'submission_date',
        },
        label: 'Submission Date',
      }, {
        prop: {
          field: 'attempts',
        },
        label: 'Attempts',
      }],
      filter: {
        page: 1,
        per_page: 20,
        q: '',
        sortby: 'created_at',
        sortorder: 'desc',
      },
      selectedRow: null,
    };
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestListCountry();
    await this.requestListSurveys(this.filter);
  },
  computed: {
    ...mapGetters('AuthModule', ['isSuperAdmin', 'isAdmin', 'isOps', 'isFinance']),
    ...mapGetters('RatingSurveyModule', ['listSurveys']),
    ...mapGetters('AppSettingModule', ['listCountry']),
  },
  watch: {
    listSurveys: {
      immediate: true,
      async handler(val) {
        if (val.data) {
          await this.refineData();
        }
      },
    },
  },
  methods: {
    ...mapActions('RatingSurveyModule', ['requestListSurveys', 'requestDetailSurvey']),
    ...mapActions('AppSettingModule', ['requestListCountry']),
    async searchSurvey() {
      this.filter.page = 1;
      await this.requestListSurveys(this.filter);
    },
    async resetSurvey() {
      this.$refs.tableSurvey.$refs.elTable.clearSort();
      this.filter.page = 1;
      this.filter.q = '';
      await this.requestListSurveys(this.filter);
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'ascending' || typeof (queryInfo.sort.order) === 'undefined' ? 'desc' : 'asc';
      if (typeof (sortby) === 'undefined' || sortby === 'submission_date') {
        sortby = 'created_at';
      }
      this.filter = Object.assign(this.filter, { page, per_page: pageSize, sortby, sortorder });
      await this.requestListSurveys(this.filter);
    },
    toggleModal() {
      this.isShowingModal = !this.isShowingModal;
    },
    refineData() {
      this.data = this.listSurveys.data.data.map((val) => {
        const country = this.listCountry.filter(c => c.code === val.customer_country);
        return { ...val,
          submission_date: moment(val.created_at).format('YYYY-MM-DD HH:mm:ss'),
          country: country.length > 0 ? country[0].name : val.customer_country,
        };
      });
      this.total = this.listSurveys.data.total;
    },
    detail(row) {
      this.selectedRow = row;
      this.toggleModal();
    },
  },
  components: {
    ModalDialogDetail,
    VueCustomTooltip,
    Button,
    Card,
    FormItem
  },
};
</script>

<style scoped>
.z-1000{
  z-index: 1000;
}
.mx-400{
  max-height: 50%;
  height: 50vh;
}
</style>



// WEBPACK FOOTER //
// src/views/RatingSurvey/SurveyList.vue